<template>
    <div ref="modal" v-if="visible" class="fixed z-20 inset-0 drop-shadow-3xl transition-opacity" tabindex="-1"
         :class="{'bg-gray-500 bg-opacity-70': backdrop}" @keydown.esc="close">
        <div class="overflow-y-scroll h-full">
            <div class="flex flex-col items-center justify-center p-2 md:p-4 min-h-full">
                <slot name="outside_top"></slot>
                <div
                    class="flex flex-col bg-white shadow-xl p-3 md:p-20 transform transition-all my-auto sm:align-middle sm:max-w-2xl md:max-w-5xl w-full">
                    <slot name="content">
                        <slot name="header"></slot>
                        <slot name="main"></slot>
                        <slot name="footer"></slot>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Watch} from "vue-property-decorator/lib/decorators/Watch";

@Options({
    name: 'Modal',
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        backdrop: {
            type: Boolean,
            default: false
        },
        closeOnEsc: {
            type: Boolean,
            default: true
        }
    }
})
export default class Modal extends Vue {
    visible!: boolean
    closeOnEsc!: boolean

    @Watch('visible')
    onVisibleChange() {
        if (this.visible) {
            // devo mettere tutto dentro il next tick per via del v-if
            this.$nextTick(() => {
                //@ts-ignore
                this.$refs.modal.focus()
            })
        }
    }

    close() {
        if (this.closeOnEsc) {
            this.$emit('update:visible', false)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
